module.exports = __webpack_public_path__ + "static/media/NibbleFig9.0f50ea85.png";